import { Box, Button, FormControl, InputLabel, MenuItem, Modal, Select, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { FinancialEntryInterface } from "../../common/interfaces";
import {
  FinancialPaymentMethod,
  FinancialPaymentMethodLabel
} from "../../components/enum/financialEnums";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import PageToaster from "../toaster/PageToaster";

interface Props {
  open: boolean;
  onClose: () => void;
  onSettled: () => void;
  entry: FinancialEntryInterface | null;
}

const FinancialEntrySettleModal: React.FC<Props> = ({ open, onClose, onSettled, entry }) => {
  const [settledAt, setSettledAt] = useState(new Date().toISOString().slice(0, 10));
  const [paymentMethod, setPaymentMethod] = useState<FinancialPaymentMethod | "">("");

  const containerId = "toaster-financial-settle-modal";
  const { autoSuccess, autoError } = usePageToast(containerId, true);
  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (open) {
      setSettledAt(new Date().toISOString().slice(0, 10));
      setPaymentMethod("");
    }
  }, [open]);

  const handleSubmit = async () => {
    if (!entry) return;
    if (!paymentMethod) {
      autoError("Selecione a forma de pagamento.");
      return;
    }
    try {
      await api.post(`/financial/entries/${entry.financial_entry_id}/settle`, {
        settled_at: settledAt,
        payment_method: paymentMethod
      });
      autoSuccess("Lançamento liquidado com sucesso!");
      onSettled();
      onClose();
    } catch (error) {
      handleHttpError(error);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "1px solid var(--border-strong)",
            p: 3,
            borderRadius: 2,
            boxShadow: 3,
            width: 380
          }}
        >
          <h2>Liquidar lançamento</h2>
          <p style={{ color: "var(--text-muted)" }}>{entry?.description}</p>

          <TextField
            fullWidth
            label="Data da liquidação"
            type="date"
            value={settledAt}
            onChange={(e) => setSettledAt(e.target.value)}
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>Forma de pagamento</InputLabel>
            <Select
              label="Forma de pagamento"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value as FinancialPaymentMethod)}
            >
              {Object.values(FinancialPaymentMethod).map((m) => (
                <MenuItem key={m} value={m}>
                  {FinancialPaymentMethodLabel[m]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ mt: 3, textAlign: "right" }}>
            <Button onClick={onClose} sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button variant="contained" onClick={handleSubmit}>
              Liquidar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default FinancialEntrySettleModal;
